/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const information = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.914 13.5h-.75a1.5 1.5 0 0 1-1.498-1.499V6.914a.75.75 0 0 0-.75-.75h-.75m.825-3.487h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    />
  </svg>
)
export default information
